module.exports = __webpack_public_path__ + "static/img/Bbno$.f56ce94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Bbno$.jpg
// module id = E7rf
// module chunks = 1